export const bundleSaleMetaPixel = process.env.REACT_APP_BUNDLE_SALE_FACEBOOK_PIXEL_ID;
export const isBundleSameMetaPixel = bundleSaleMetaPixel != "" && bundleSaleMetaPixel != "none";